import { render, staticRenderFns } from "./Consumerproducts.vue?vue&type=template&id=70985b22&scoped=true"
import script from "./Consumerproducts.vue?vue&type=script&lang=js"
export * from "./Consumerproducts.vue?vue&type=script&lang=js"
import style0 from "./Consumerproducts.vue?vue&type=style&index=0&id=70985b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70985b22",
  null
  
)

export default component.exports